/**
 * Patient validation — user-facing messages (single source of truth).
 * Used by Zod schemas, cross-section hooks, and submit-time rules in `patientValidation.ts`.
 */

// ----- Health insurance card (Zod superRefine / shared insurer number) -----
export const HEALTH_INSURER_NUMBER_REQUIRED = '保険者番号は必須です。';
/** 保険証「記号」欄 (card_mark) */
export const HEALTH_INSURANCE_CARD_SYMBOL_REQUIRED = '記号は必須です。';

// ----- Medical aid -----
export const MEDICAL_AID_NUMBER_TYPE_ERROR =
  '【医療助成　公費負担番号】入力されたコードの種別が違います。';

export const MEDICAL_AID_NUMBER_NOT_IN_MASTER =
  '【公費負担番号】入力されたコードはマスタに存在しません。';

export const MEDICAL_AID_NUMBER_REQUIRED = '保険種別が [無し] 以外の場合、公費負担番号は必須です。';

export const MEDICAL_AID_PUBLIC_RECIPIENT_NUMBER_REQUIRED =
  '保険種別が [無し] 以外の場合、公費受給者番号は必須です。';

export const MEDICAL_AID_APPLICATION_START_DATE_REQUIRED = '医療助成登録時、適用開始日は必須です。';

// ----- Late-elderly (後期高齢) -----
export const LATE_ELDERLY_INSURER_NUMBER_ERROR =
  '保険者番号に誤りがあります後期高齢の選択は39×××のみ選択が可能です。';

export const LATE_ELDERLY_INSURER_NUMBER_LENGTH_ERROR =
  '【後期高齢】を指定した場合、被保険者番号は8桁で入力してください。';

export const LATE_ELDERLY_RELATIONSHIP_ERROR =
  '【後期高齢】を指定した場合、続柄は「本人」を選択してください。';

// ----- Relationship 67 -----
export const RELATIONSHIP_67_INSURER_NUMBER_ERROR =
  '【67（本人）】を指定した場合、保険者番号は「67xxxxxx」のみ選択可能です。';

// ----- Age / elderly certificate -----
export const AGE_ELDERLY_CERTIFICATE_ERROR = '前期高齢者を設定できる年齢ではありません。';

export const AGE_EARLY_ELDERLY_NOT_ALLOWED_AT_75_PLUS_CONFIRM =
  '前期高齢者を設定できる年齢ではありませんが、このまま処理を続行してよろしいですか？';

// ----- Patient cost (6歳以下乳幼児2割) -----
export const PATIENT_COST_PRESCHOOL_RATE_CHANGE_WARNING =
  '負担割合を変更してください。6歳の誕生日以降、最初に迎える3月31日までが2割負担です。';

// ----- Qualification date × elderly burden (certificate) -----

export const ELDERLY_CERT_THIRTY_PERCENT_BEFORE_HEISEI18_ERROR =
  '平成18年10月01日より前に【3割負担】は指定できません。';

export const ELDERLY_CERT_TWENTY_PERCENT_QUAL_DATE_EXCLUDED_ERROR =
  '平成18年10月01日から平成26年3月31日の資格取得者は【2割負担】は指定できません。';

export const ELDERLY_CERT_TEN_PERCENT_AFTER_HEISEI26_RULE_ERROR =
  '平成26年4月2日以降に70歳になる場合は【1割負担】は指定できません。';

// ----- validateHealthInsuranceCard (manual errors array) -----
export const HEALTH_INSURER_KIND_NAME_REQUIRED = '保険者種別は必須です。';
export const HEALTH_INSURER_NAME_REQUIRED = '保険者名称は必須です。';

// ----- Submit / modal rules (`src/utils/patientValidation.ts`) -----
export const PATIENT_NAME_REQUIRED_ERROR = '患者名は必須項目です。';
export const PATIENT_NAME_KANA_REQUIRED_ERROR = '患者名カナは必須項目です。';
export const BIRTH_DATE_ERROR =
  '入力された生年月日に誤りがあります。確認後、訂正して登録してください。';

export const LATE_ELDERLY_INSURANCE_UNDER_65_CONFIRM =
  '後期高齢者を設定できる年齢ではありませんが、このまま処理を続行してよろしいですか？';

export const OVER_75_MUST_SET_LATE_ELDERLY_CONFIRM =
  '75歳以上は後期高齢者を設定しなければなりませんが、このまま処理を続行してよろしいですか？';

export const OVER_75_EARLY_ELDERLY_CERT_WARNING =
  '75歳以上の方に前期高齢者証の設定がされています。後期高齢ではありませんか？';

export const OVER_75_NO_LATE_ELDERLY_INSURANCE_CONFIRM =
  '75歳以上の方に後期高齢者保険が設定されていません。このまま登録してもよろしいですか？';

export const AGE_70_TO_74_EARLY_ELDERLY_REQUIRED_CONFIRM =
  '70歳以上75歳未満は前期高齢者を設定しなければなりませんが、このまま処理を続行してよろしいですか？';

/** 社会保険等で保険証マーク必須のとき */
export const HEALTH_INSURANCE_CARD_MARK_REQUIRED = '保険証マークは必須です。';

export const HEALTH_INSURER_NUMBER_FORMAT_ERROR = '保険者番号は6～8桁の数字で入力してください。';

export const INSURED_NAME_KANA_KATAKANA_ONLY_ERROR =
  '被保険者カナはカタカナのみで入力してください。';

export const PATIENT_ADDRESS_KANA_FORMAT_ERROR = '住所カナの書式が正しくありません。';

export const PATIENT_COST_RATE_MAX_ERROR = '患者負担率は10以下で入力してください。';

// ----- Patient address confirm dialogs (受診者住所 / 訪問住所) -----
export const ADDRESS3_CALC_TARGET_CONFIRM_QUESTION =
  '「算定対象」にチェックされましたが、このまま進めてよろしいですか？';
export const ADDRESS3_CALC_TARGET_CONFIRM_HINT =
  '「訪問施術料 １」（単独）で算定したい場合のみこちらにチェックしてください。';
export const SPECIAL_AREA_ADDITION_WARNING =
  '施術する場所（住所）が特別地域加算対象の場合、【はい】を選択しください。';
